import React from 'react';

import { RightSidebar } from "src/pages/_partials/Layout";
import { BundleInterface } from "src/store/callrecorder/bundlesSlice";
import RowInfo from "src/componets/RowInfo";
import { ButtonDownload } from "src/componets/Buttons";

const _SidebarShow = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  const renderDetails = () => {
    if(!bundle) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={bundle.id} />
          <RowInfo left='Bundle Name' right={bundle.name} />
          <RowInfo left='Platform' right={bundle.platform} />
          <RowInfo left='Environment' right={bundle.prod_env ? 'production' : 'development'} />
          <RowInfo left='Shared Secret' right={bundle.shared_secret} />
          <RowInfo left='Twilio Service SID' right={bundle.twilio_service_sid} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>App Store Connect API</h6>

          <RowInfo left='Key ID' right={bundle.app_store_connect_api_key_id || '—'} />
          <RowInfo left='Issuer ID' right={bundle.app_store_connect_api_issuer_id || '—'} />
          <RowInfo left='Private Key' right={
            bundle.app_store_connect_api_private_key_url
              ? <ButtonDownload href={bundle.app_store_connect_api_private_key_url} />
              : '—'
          } />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Firebase Service Account</h6>

          <RowInfo left='Project ID' right={bundle.firebase_project_id || '—'} />
          <RowInfo left='Client Email' right={bundle.firebase_client_email || '—'} />
          <RowInfo left='Private Key' right={bundle.firebase_private_key ? 'set' : '—'} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar collapsible>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
